import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

import { useDeleteDocument } from '../../hooks/useDocuments';
import { documentDisplayName } from '../../lib/documentName';
import type { DocumentResponse } from '../../types';

interface Props {
  collectionId: string;
  document: DocumentResponse | null;
  onOpenChange: (open: boolean) => void;
}

export function DeleteDocumentDialog({ collectionId, document, onOpenChange }: Props) {
  const { mutateAsync, isPending } = useDeleteDocument(collectionId);

  async function handleConfirm() {
    if (!document) return;
    await mutateAsync(document.id);
    onOpenChange(false);
  }

  return (
    <AlertDialog open={Boolean(document)} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Remover documento</AlertDialogTitle>
          <AlertDialogDescription>
            Tem certeza que deseja remover{' '}
            <span className="text-foreground font-semibold">
              "{document ? documentDisplayName(document) : ''}"
            </span>
            ?
            {(document?.chunk_count ?? 0) > 0 && (
              <>
                {' '}
                Isso removerá{' '}
                <span className="text-destructive font-semibold">
                  {document?.chunk_count} chunk(s)
                </span>{' '}
                indexado(s).
              </>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          {/* eslint-disable-next-line @typescript-eslint/no-misused-promises -- async event handler */}
          <AlertDialogAction variant="destructive" onClick={handleConfirm} disabled={isPending}>
            {isPending ? 'Removendo…' : 'Remover'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
